export enum CrcStatusType {
    Invited = 'Invited',
    RequestedApproval = 'Requested Approval',
    Active = 'Active',
}
